/* eslint-disable import/no-anonymous-default-export */
import { LOGIN } from "routes/route.constant";
import Login from "pages/Login";

export default {
  path: LOGIN,
  element: Login,
};
